//@ts-ignore
import groupedCategories from "highcharts-grouped-categories";
import barline from "./plugins/barline";
import horizontalAxisTitle from "./plugins/horizontal-axis-title";
import brokenAxisVisuals from "./plugins/broken-axis-visuals";
import imitateBrokenAxis from "./plugins/imitate-broken-axis";
import pieTitle from "./plugins/pie-title";
import dateFormatters from "./plugins/dateformats";
function configure(Highcharts) {
    groupedCategories(Highcharts);
    barline(Highcharts);
    brokenAxisVisuals(Highcharts);
    horizontalAxisTitle(Highcharts);
    imitateBrokenAxis(Highcharts);
    pieTitle(Highcharts);
    dateFormatters(Highcharts);
}
export default configure;
